export default "__VITE_ASSET__DaUAESGA__"